import { combineReducers } from 'redux';
import answered from './answered';
import saved from './saved';
import submit from './submit';
import upcoming from './upcoming';
import forms from './forms';
import sendSurvey from './sendSurvey';
import pdfExport from './exportToPDF';
import submitReferralForm from './submitReferralForm';
import reqReferralForms from './reqReferralForms';
import reqFormResult from './reqFormResult';
import upcomingSurvey from './upcoming-survey';
import upcomingSurveyAnswers from './upcoming-survey-answers';
import upcomingSurveyProceed from './upcoming-survey-proceed';
import upcomingSurveyCompletions from './upcoming-survey-completions';
import upcomingSurveyCancelFilling from './upcoming-survey-cancel-filling';
import appointmentConsent from './appointment-consent-req';

export default combineReducers({
  answered,
  saved,
  submit,
  upcoming,
  forms,
  sendSurvey,
  pdfExport,
  submitReferralForm,
  reqReferralForms,
  reqFormResult,
  upcomingSurvey,
  upcomingSurveyAnswers,
  upcomingSurveyProceed,
  upcomingSurveyCompletions,
  upcomingSurveyCancelFilling,
  appointmentConsent,
});



// WEBPACK FOOTER //
// ./src/redux/surveys/index.js